import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ContactDetailsService } from '../contact-details.service';

export function NumberValidator(contactDetailsService: ContactDetailsService, recordId: number): AsyncValidatorFn {
  return (control: AbstractControl): Observable<any> => {
    return contactDetailsService.isValidNumber(control.value.replace(/ /g, ''), recordId).map((res: any) => {
      return !res ? null : res.INVALID_MSISDN || res.MSISDN_EXISTS_IN_PROJECT ? res : null;
    });
  };
}
